/**
 * @class Marker
 *
 */
class Marker {
    /**
     *
     * @param {Number|String} lat
     * @param {Number|String} lng
     * @param {Object} entry
     * @param pos
     */
    constructor(lat = 0, lng = 0, entry = {}, pos) {
        this.pos = pos || {
            lat, lng
        };
        this.entry = entry;
    }
}

export default Marker;
